module.exports = "<div>Work</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Work.vue
 ** module id = 49
 ** module chunks = 0
 **/